export function toSearchParams(query: Readonly<Record<string, unknown>>): URLSearchParams {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(query).sort(([left], [right]) => {
    if (left < right) return -1;
    if (left > right) return 1;
    return 0;
  })) {
    if (value === undefined || value === null || value === '') continue;
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      params.set(key, String(value));
    }
  }

  return params;
}
